<template>
    <v-container>
        Test
    </v-container>
</template>

<script>
/* eslint-disable */
   export default{
    name:"dashboard.index",
    data: ()=>{
      return {
        
      }
    },
    watch: {
      
    },

    mounted () {

    },

    methods: {
      
    },
}
</script>